export default {
  uploadNFCSKU: 'Upload NFC SKU',
  refreshNSPNFC: 'Refresh NSP NFC SKU',
  refreshPFNFC: 'Refresh PF NFC SKU',
  refreshRFID: 'Refresh RFID SKU',
  refreshWaveRun: 'Refresh Wave Run',
  updatedTime: 'Update time ',
  skuHistory: 'SKU History'
}
